import z from 'zod';
import { territorialIdSchema } from './paramTypeSchema.js';
import { timestampSchema } from './commonSchemas.js';
/**
 * Schema per OrganizationDefRow
 * Rappresenta il tipo di riga della tabella organizations
 * @db_table organizations
 */
export const organizationDefRowSchema = z.object({
    /** ID dell'organizzazione */
    id: z.number().int().nonnegative(),
    /** Nome breve organizzazione per identificazione rapida */
    name: z.string().min(1, "Il nome dell'organizzazione è obbligatorio"),
    /** Denominazione completa ufficiale dell'organizzazione */
    full_name: z.string().optional().nullable(),
    /** ID territoriale di competenza secondo schema territorialIdSchema */
    ambito: territorialIdSchema,
    /** Indirizzo sede organizzazione */
    address: z.string().optional().nullable(),
    /** Numero telefono principale */
    phone: z.string().max(30).optional().nullable(),
    /** Email principale di contatto (formato validato) */
    email: z.string().email("Email non valida").optional().nullable(),
    /** Sito web ufficiale (URL validato) */
    website: z.string().url("URL non valido").optional().nullable(),
    /** Nome tema UI personalizzato per branding organizzazione */
    theme: z.string().max(100).optional().nullable(),
    /** Stato attivazione: true = organizzazione attiva, false = disabilitata */
    is_active: z.boolean(),
    /** Configurazioni personalizzate in formato JSONB */
    settings: z.record(z.string(), z.any()).optional().nullable(),
    /** Data di creazione */
    created_at: timestampSchema,
    /** Data di ultimo aggiornamento */
    updated_at: timestampSchema
});
export const organizationDefRowSchemaNoId = organizationDefRowSchema.omit({ id: true, created_at: true, updated_at: true });
//# sourceMappingURL=organizationDefSchema.js.map